import React, { useState } from "react";
import "./css/ReportIssue.css";
import { EmailService } from "../../Utils/EmailUtils";

export const ReportIssue: React.FC = () => {
    const [message, setMessage] = useState("");
    const [replyEmail, setReplyEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [isSending, setIsSending] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!message.trim() || !replyEmail.trim()) return;

        setIsSending(true);

        // Simulate delay
        setTimeout(async () => {
            await EmailService.sendIssueReport({
                message,
                replyEmail
            });

            setIsSending(false);
            setSubmitted(true);
        }, 2000);
    };

    return (
        <div className="report-container">
            {!submitted ? (
                <form className="report-form" onSubmit={handleSubmit}>
                    <p className="report-intro">
                        If you’ve encountered a problem while using Skitterbook, you can
                        report it here. Our support team will review your message and get
                        back to you as soon as possible.
                    </p>

                    <label className="report-label">
                        Describe the issue:
                        <textarea
                            className="report-textarea"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Tell us what happened…"
                        />
                    </label>

                    <label className="report-label">
                        Your email address:
                        <input
                            type="email"
                            className="report-input"
                            value={replyEmail}
                            onChange={(e) => setReplyEmail(e.target.value)}
                            placeholder="you@example.com"
                        />
                    </label>

                    <button className="report-button" type="submit" disabled={isSending}>
                        {isSending ? "Sending…" : "Submit Issue"}
                    </button>
                </form>
            ) : (
                <div className="report-confirmation">
                    <h2>Thank you</h2>
                    <p>
                        Your issue has been submitted. Our support team will investigate the
                        problem and respond to <strong>{replyEmail}</strong>.
                    </p>
                    <p>
                        We appreciate your patience while we look into this. Most issues are
                        resolved quickly, and we’ll keep you updated.
                    </p>
                </div>
            )}
        </div>
    );
};

export default ReportIssue;
